import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    outcomeIcon: {
        fontSize: 16,
        display: 'block',
    },
    approved: {
        color: palette.success.main,
    },
    denied: {
        color: palette.error.main,
    },
    error: {
        color: palette.error.main,
    },
    pending: {
        color: 'text.secondary',
    },
    cancelled: {
        color: 'text.secondary',
    },
}

export const OutcomeBannerStyles: moduleStyleType = {
    container: {
        marginBottom: 3,
    },
}

export const OutcomeStyles: moduleStyleType = {
    iconContainer: {
        marginRight: 1,
    },
}
